import React from "react";
import useClientConfig from "../../../../../config/careers/clientConfig";


const AdelaideOvalBanner = ({ isRegisterPage }: any) => {
    const { clientAssetsLink } = useClientConfig();
    return (
        <div
            className="banner-wrapper adelaide-oval-banner"
            style={{ backgroundImage: `url("${clientAssetsLink}/banner.jpg")` }}
        >
            <div className="banner-content container mx-auto" >
                <div className="banner-text">
                    <h1>Careers</h1>
                </div>
            </div>
        </div>
    );
};

export default AdelaideOvalBanner;
